module.exports = __webpack_public_path__ + "img/partnerzy-08_ongeo_services.4bc13264.svg";